// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__YCU-a","inputDescription":"styles_inputDescription__OrcVC"};